import { getProxyUrl } from 'academy-common-lib/utils/url';
// @ts-expect-error Could not find a declaration file for module
import academyLogo from 'bender-url!../../images/hubspot-academy-logo-color.svg';
import PublicPageLayout from '../features/publicLayout/components/PublicPageLayout';
import { supportedPublicLanguages } from 'academy-common-lib/constants/academySupportedLanguages';
import DocumentHead from '../features/publicSeo/components/DocumentHead';
import { NavMarker } from 'react-rhumb';
import OpenGraph from '../features/publicSeo/components/OpenGraph';
import I18n from 'I18n';
import { useEffect } from 'react';
import Schema from '../features/publicSeo/components/Schema';
import usageTracker from '../utils/usageTracker';
import { Paths } from './RoutingConstants';
import AlternateLanguageLinks from '../features/publicSeo/components/AlternateLanguageLinks';
import HomepageHeroSection from '../features/homepage/HomepageHeroSection';
import PopularCoursesSection from '../features/homepage/PopularCoursesSection';
import SignupSectionMinimalDark from '../features/staticSections/SignupSectionMinimalDark';
import WhyLearnSection from '../features/staticSections/WhyLearnSection';
import TrendingTopicsSection from '../features/staticSections/TrendingTopicsSection';
import CoursesAndCertificationsSplitSection from '../features/staticSections/CoursesAndCertificationsSplitSection';
import CertificationsSection from '../features/staticSections/CertificationsSection';
import ErrorBoundary from '../components/ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Homepage = () => {
  useEffect(() => {
    document.title = I18n.text('academyPublic.homepage.documentTitle');
    usageTracker.track('pageView', {
      screen: 'homepage',
      subscreen: 'homepage'
    });
  }, []);
  return /*#__PURE__*/_jsxs(PublicPageLayout, {
    availableLanguages: [...supportedPublicLanguages],
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "HOMEPAGE_LOAD"
    }), window.prerenderReady = true, /*#__PURE__*/_jsx(ErrorBoundary, {
      errorMessage: null,
      children: /*#__PURE__*/_jsxs(DocumentHead, {
        children: [/*#__PURE__*/_jsx("link", {
          href: getProxyUrl(Paths.HOMEPAGE),
          rel: "canonical"
        }), /*#__PURE__*/_jsx(AlternateLanguageLinks, {
          languages: [...supportedPublicLanguages]
        }), /*#__PURE__*/_jsx("meta", {
          content: I18n.text('academyPublic.homepage.pageDescription'),
          name: "description"
        }), /*#__PURE__*/_jsx(OpenGraph, {
          description: I18n.text('academyPublic.homepage.pageDescription'),
          image: academyLogo,
          imageAlt: 'HubSpot Academy Logo',
          title: I18n.text('academyPublic.homepage.seoTitle'),
          url: getProxyUrl(Paths.HOMEPAGE)
        })]
      })
    }), /*#__PURE__*/_jsx(ErrorBoundary, {
      errorMessage: null,
      children: /*#__PURE__*/_jsx(Schema, {
        object: {
          ['@type']: 'EducationalOrganization',
          name: 'HubSpot Academy',
          url: 'https://academy.hubspot.com',
          isAccessibleForFree: true,
          parentOrganization: {
            ['@type']: 'Organization',
            name: 'HubSpot',
            url: 'https://www.hubspot.com',
            logo: 'https://upload.wikimedia.org/wikipedia/commons/3/3f/HubSpot_Logo.svg',
            sameAs: ['https://www.wikidata.org/wiki/Q5926631', 'https://en.wikipedia.org/wiki/HubSpot']
          }
        }
      })
    }), /*#__PURE__*/_jsx(ErrorBoundary, {
      children: /*#__PURE__*/_jsx(HomepageHeroSection, {})
    }), /*#__PURE__*/_jsx(ErrorBoundary, {
      children: /*#__PURE__*/_jsx(PopularCoursesSection, {})
    }), /*#__PURE__*/_jsx(ErrorBoundary, {
      errorMessage: null,
      children: /*#__PURE__*/_jsx(TrendingTopicsSection, {})
    }), /*#__PURE__*/_jsx(ErrorBoundary, {
      errorMessage: null,
      children: /*#__PURE__*/_jsx(CertificationsSection, {})
    }), /*#__PURE__*/_jsx(ErrorBoundary, {
      errorMessage: null,
      children: /*#__PURE__*/_jsx(CoursesAndCertificationsSplitSection, {})
    }), /*#__PURE__*/_jsx(ErrorBoundary, {
      errorMessage: null,
      children: /*#__PURE__*/_jsx(WhyLearnSection, {})
    }), /*#__PURE__*/_jsx(ErrorBoundary, {
      children: /*#__PURE__*/_jsx(SignupSectionMinimalDark, {
        hubsSignupCta: "academy-home-bottom"
      })
    })]
  });
};
export default Homepage;